const SUBDOMAIN_LABEL_ENV_VARS: { envVarName: string; label: string }[] = [
  { envVarName: 'REACT_APP_NBI_SHORTCODES', label: 'NBI' },
  { envVarName: 'REACT_APP_FEDERATED_SHORTCODES', label: 'FED' },
]

const DEFAULT_COMPANY_LABEL = 'NBI'

export const getCompanyLabel = (): string => {
  const subdomain = window.location.hostname.split('.')[0]

  for (const { envVarName, label } of SUBDOMAIN_LABEL_ENV_VARS) {
    const shortcodes = (process.env[envVarName]?.split(',') || [])
      .map((shortcode) => shortcode.trim())
      .filter(Boolean)

    if (shortcodes.some((shortcode) => subdomain === shortcode)) {
      return label
    }
  }

  return DEFAULT_COMPANY_LABEL
}
